import Image from "next/image";
import Link from "next/link";

const Media_Card = ({ imgSrc, title, link, setHeight, slug }) => {
  return (
    <div className="w-full">
      <div className="imgCont mb-4 lg:mb-[1.2vw]">
        <Image
          src={imgSrc}
          width={889}
          height={513}
          alt={title}
          className={setHeight ? `h-[250px] object-cover` : ""}
        />
      </div>
      <Link
        href={link}
      >
        <h5 className="font-primary mb-4 lg:mb-[1.0vw] text-black text-[20px] font-bold lg:text-[1.2vw] pr-3">
          {title}
        </h5>
      </Link>
      {/* <Link
        href={link}
        className="read text-[#363435] uppercase hover:text-black hover:tracking-[2px] text-[14px] lg:text-[1vw] transition-all duration-300 ease-in-out"
      >
        Read More +
      </Link> */}
    </div >
  );
};

export default Media_Card;
